module.exports = __webpack_public_path__ + "static/img/u9101.7132679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u9101.jpg
// module id = mA17
// module chunks = 73